import { render } from "./PortalWallet.vue?vue&type=template&id=2d8d2350"
import script from "./PortalWallet.vue?vue&type=script&lang=js"
export * from "./PortalWallet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__